import React, {useState} from 'react'
import {activateAd, activateOrPauseAdCampaign, createAd, pauseAd} from "../../services/facebook-ads-service";
import {saveSingleAd} from "../../services/facebook-ad-data.service";
import ShowProgressSpinner from "../../../common/ui/show-progress-spinner";
import {saveSingleCampaign} from "../../services/facebook-campaign-data.service";

const EditFacebookAdCampaign = ({adCampaign, afterEditAdCampaignAction}) => {
    const [saveInProgress, setSaveInProgress] = useState(false);

    const activateFacebookAdCampaign = async () => {
        setSaveInProgress(true);

        adCampaign.status = 'ACTIVE';

        await activateOrPauseAdCampaign(adCampaign);
        await saveSingleCampaign(adCampaign);

        setSaveInProgress(false);
        afterEditAdCampaignAction();
    }

    const pauseFacebookAdCampaign = async () => {
        setSaveInProgress(true);

        adCampaign.status = 'PAUSED';

        await activateOrPauseAdCampaign(adCampaign);
        await saveSingleCampaign(adCampaign);

        setSaveInProgress(false);
        afterEditAdCampaignAction();
    }

    return (
        <>
            {adCampaign &&
                <div className="flex items-center justify-end mr-2">
                    <div className="">
                        <ShowProgressSpinner dataFetchInProgress={saveInProgress}/>
                    </div>

                    {adCampaign.status === 'PAUSED' && !saveInProgress &&
                        <button
                            onClick={activateFacebookAdCampaign}
                            className="button-sky px-2 py-1">
                            Activate Ad Campaign
                        </button>
                    }

                    {adCampaign.status === 'ACTIVE' && !saveInProgress &&
                        <button
                            onClick={pauseFacebookAdCampaign}
                            className="button-outline-red px-2 py-1">
                            Pause Ad Campaign
                        </button>
                    }
                </div>
            }
        </>
    )
}

export default EditFacebookAdCampaign
